import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleTecnical } from "../hooks/roles/ProtectedRoleTecnical";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";

const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleEsperarInformacion = React.lazy(
  () =>
    import(
      "../components/task/tecnical/tareaDetalleEsperarInformacion/tarea-detalle-esperar-informacion"
    )
);
export function tareaDetalleEsperarInformacion() {
  return (
    <Route
      path="/tarea-detalle-Esperar-Informacion"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleTecnical>
              <LazySuspense>
                <TareaDetalleEsperarInformacion />
              </LazySuspense>
            </ProtectedRoleTecnical>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
